module.exports = __webpack_public_path__ + "img/People Manager.a84b15f5.png";